import { atom } from "recoil";

const favoriteNumberStore = atom<number>({
	key: "favoriteNumberStore",
	default: 0,
});

export default favoriteNumberStore;
